import { ApiProperty } from "@nestjs/swagger";

export class PackingBomRequest{
    @ApiProperty()
    unitId?:number;
    @ApiProperty()
    saleOrderId?:number;
    @ApiProperty()
    fromDate?: Date;
    @ApiProperty()
    toDate?: Date;
}